import { FoodBrand, FoodName, StyledNameAndPortion } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import { EdamamEntry } from "model/food/types"
import EdamaPortionUnitPickerFormItem from "./EdamaPortionUnitPickerFormItem"
import { IEdamaUnit } from "model/food/types/edama.types"
import FutureMealIcon from "components/Icons/FutureMealIcon"

interface IProps {
  edama: EdamamEntry
  portionValue: number
  onPortionChange: (portion: number) => void
  unitOptions: IEdamaUnit[]
  unitValue: string
  onUnitChange: (unit: string) => void

  disabled?: boolean
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
  isMeal?: boolean
  gram: null | number
  isFutureScheduleMeal?: boolean
}

const EdamaNameAndPortion = (props: IProps) => {
  const {
    edama,
    onPortionChange,
    portionValue,
    unitValue,
    onUnitChange,
    disabled,
    unitOptions,
    setIsPortionValid,
    calories,
    gram,
    isFutureScheduleMeal,
  } = props

  return (
    <StyledNameAndPortion>
      <FlexBox
        $alignItems="center"
        $gap={8}
        style={{ padding: "4px 0", width: "100%" }}
      >
        <FoodName>{edama.name}</FoodName>

        {isFutureScheduleMeal && <FutureMealIcon />}
      </FlexBox>

      {edama.brand ? <FoodBrand>{edama.brand}</FoodBrand> : null}

      <EdamaPortionUnitPickerFormItem
        unitValue={unitValue}
        portionValue={portionValue}
        onPortionChange={onPortionChange}
        onUnitChange={onUnitChange}
        unitOptions={unitOptions}
        setIsPortionValid={setIsPortionValid}
        calories={calories}
        disabled={disabled}
        gram={gram}
      />
    </StyledNameAndPortion>
  )
}

export default EdamaNameAndPortion
